module.exports = __webpack_public_path__ + "img/dishwasher.16f3969c.png";